import React from "react";
import ProductCard from "./ProductCard";
import ProductCardSkeleton from "./ProductCardSkeleton";

const ProductGrid = ({
  products,
  viewMode,
  isLoading,
  onProductClick,
  currentStore,
}) => {
  if (isLoading) {
    return (
      <div
        className={`grid gap-6 ${
          viewMode === "grid"
            ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-"
            : "grid-cols-1"
        }`}
      >
        {Array.from({ length: 8 }).map((_, index) => (
          <ProductCardSkeleton key={index} viewMode={viewMode} />
        ))}
      </div>
    );
  }

  return (
    <div
      className={`grid gap-6 ${
        viewMode === "grid"
          ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
          : "grid-cols-1"
      }`}
    >
      {products?.map((product) => (
        <ProductCard
          currentStore={currentStore}
          key={product.iProductId}
          product={product}
          viewMode={viewMode}
          onClick={onProductClick}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
